export default __webpack_public_path__ + "static/farm_banner-e4be6755419a27443fc6580a0bba7fe7.jpg";